// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IFullTipSchema {
  /** Полный текст для поисковой строки, включая поле text **/
  fullText: string;
  /** Текст дополнения для поисковой строки **/
  text: string;
  /** Тип дополнения для поисковой строки **/
  type: EType;
}

export enum EType {
  /** Тип дополнения для поисковой строки, сгенерированный ml **/
  'Ml' = 'ml',
  /** Тип дополнения для поисковой строки, сгенерированный словарем **/
  'Regular' = 'regular',
}
